import { HomeFilled } from '@ant-design/icons';

import Account from './account.svg';
import AutoFocus from './auto-focus.svg';
import Camera from './camera.svg';
import CloudFile from './cloud-file.svg';
import CurveEngraving from './curve-engraving.svg';
import Document from './document.svg';
import Frame from './frame.svg';
import Go from './go.svg';
import PathPreview from './path-preview.svg';
import Redo from './redo.svg';
import SelectMachine from './select-machine.svg';
import Trash from './trash.svg';
import Undo from './undo.svg';

export default {
  Account,
  AutoFocus,
  Camera,
  CloudFile,
  CurveEngraving,
  Document,
  Frame,
  Go,
  Home: HomeFilled,
  PathPreview,
  Redo,
  SelectMachine,
  Trash,
  Undo,
};
